import easy from "./easy/zhCN";

export default {
    easy: easy
}
